import React, { useState } from "react";
import { colors, spacing } from "../../utils/designTokens";
import { useIsMobile } from "../../hooks/useResponsive";
import { useProspeccionData } from "../../hooks/useProspeccionData";
import ProspeccionMapa from "../admin/ProspeccionMapa";
import CrmFicha from "../../components/CrmFicha";

/**
 * Pestaña Mapa (comercial y superadmin): el mapa como protagonista, a pantalla
 * casi completa —sobre todo en mobile— con los filtros compartidos (mismos que
 * la lista) y GPS "cerca mío". Tocar una parcela/punto abre la ficha CRM.
 */
export default function MapaProspeccion({ setSelected }) {
  const isMobile = useIsMobile();
  const { puntos, crmByPadron, comerciales, loading, updateCrm } = useProspeccionData();
  const [ficha, setFicha] = useState(null);

  return (
    <div style={{ padding: isMobile ? spacing[2] : spacing[4], maxWidth: 1600, margin: "0 auto" }}>
      {loading ? (
        <div style={{ textAlign: "center", padding: spacing[8], color: colors.gray600 }}>Cargando mapa…</div>
      ) : (
        <ProspeccionMapa
          puntos={puntos}
          crmByPadron={crmByPadron}
          onOpenFicha={(p) => setFicha(p)}
          mapHeight={isMobile ? "calc(100dvh - 195px)" : "calc(100vh - 220px)"}
        />
      )}
      <CrmFicha
        open={!!ficha}
        onClose={() => setFicha(null)}
        padron={ficha?.padron}
        punto={ficha}
        crm={ficha ? crmByPadron[String(ficha.padron)] : null}
        comerciales={comerciales}
        onSaved={updateCrm}
        setSelected={setSelected}
      />
    </div>
  );
}
